import clsx from 'clsx'
import { MouseEvent, useRef } from 'react'

import { ArrowDown } from '@/shared/lib/@deprecated/iport-icons'

import { Tag } from './tag/tag'

import cl from './tags.module.scss'

type Tag = {
	ID: number
	SHORT_NAME: string
	CODE: string
	BACKGROUND_COLOR: string
	TEXT_COLOR: string
	CUSTOM_LINK: string
	NAME: string
	SORT: number
	ACTIVE_TO: string
}

type TagsProps = {
	tags: Tag[]
	size?: 'S' | 'M'
	isNew?: boolean
	className?: string
	showOnlyFirst?: boolean
	isNotAvailable?: boolean
}

const newTag = {
	ID: 321,
	SHORT_NAME: 'Новинка',
	CODE: '123',
	BACKGROUND_COLOR: '#46CA9A',
	TEXT_COLOR: '#FFF',
	CUSTOM_LINK: '/new',
	NAME: 'Посмотреть все новинки',
	SORT: 100,
	ACTIVE_TO: ''
}

export const prepareTags = (tags: Tag[], isNew: boolean) => {
	if (!tags?.length && !isNew) return []

	const validTags = tags?.filter(tag => tag?.SHORT_NAME)
	if (isNew) {
		validTags.push(newTag)
	}
	const sortedTags = validTags?.sort((tagA, tagB) => tagA.SORT - tagB.SORT)

	return sortedTags
}

export const TagsList = ({ tags, isNew = false, className, showOnlyFirst = false, isNotAvailable }: TagsProps) => {
	if (isNotAvailable) {
		return <div />
	}
	const preparedTags = prepareTags(tags, isNew)

	if (showOnlyFirst && preparedTags[0]) {
		const firstItem = preparedTags[0]

		return <Tag tag={firstItem} />
	}

	return (
		<div className={clsx(cl.tools, cl.regular, className)}>
			<div className={cl.tags}>
				<ul className={cl.tags__list}>
					{preparedTags.map(tag => (
						<li key={tag.ID}>
							<Tag tag={tag} />
						</li>
					))}
				</ul>
			</div>
		</div>
	)
}

type TagsCollapsedProps = TagsProps & {
	isOpen: boolean
	onToggle: () => void
	className?: string
}

export const TagsCollapsed = ({ tags, isNew, isOpen, onToggle, isNotAvailable }: TagsCollapsedProps) => {
	const tagsListRef = useRef<HTMLUListElement>(null)

	if (isNotAvailable) {
		return <div />
	}

	const preparedTags = prepareTags(tags, isNew)
	const showButton = preparedTags.length > 1

	const toggleTagsPanel = (e: MouseEvent<HTMLButtonElement>) => {
		e.stopPropagation()
		onToggle?.()

		const el = tagsListRef.current

		if (el.style.maxHeight) {
			el.style.maxHeight = null
		} else {
			el.style.maxHeight = `${el.scrollHeight}px`
		}
	}

	const buttonClasses = clsx(cl.tags__button, {
		[cl.tags__button__active]: isOpen
	})

	return (
		<div className={clsx(cl.tools, cl.collapsed)}>
			<div className={cl.tags}>
				<ul className={cl.tags__list} ref={tagsListRef}>
					{preparedTags.map(tag => (
						<li key={tag.ID}>
							<Tag tag={tag} />
						</li>
					))}
				</ul>
				{showButton && (
					<button className={buttonClasses} onClick={toggleTagsPanel}>
						<ArrowDown size={18} />
					</button>
				)}
			</div>
		</div>
	)
}
